import makeStyles from '@mui/styles/makeStyles';
import { grey, isDark } from 'global/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
  },
  smallMarginTopBottom: {
    marginBottom: theme.spacing(2),
  },
  filters: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '@media print': {
      display: 'none',
    },
    '&> :first-child': {
      marginRight: theme.spacing(2),
    },
    '&> div': {
      minWidth: theme.spacing(10),
    },
    [theme.breakpoints.down('lg')]: {
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(2),
    },

    '& .MuiFormLabel-root': {
      left: -14,
    },
  },
  overline: {
    marginLeft: theme.spacing(1),
  },
  filterContainer: {
    borderRadius: 5,
    padding: theme.spacing(1),
    paddingTop: theme.spacing(0.5),
    marginTop: theme.spacing(2),
  },
  buttonGroup: {
    margin: theme.spacing(0.25),

    '& .MuiButton-contained.Mui-disabled': {
      backgroundColor: isDark(theme) ? grey(theme, 600) : grey(theme, 100),
      color: theme.palette.action.disabled,
    },

    '& .MuiButton-contained': {
      backgroundColor: isDark(theme) ? grey(theme, 700) : grey(theme, 300),
      color: theme.palette.getContrastText(isDark(theme) ? grey(theme, 700) : grey(theme, 300)),
      borderColor: isDark(theme) ? `${theme.palette.background.paper} !important` : grey(theme, 400),

      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  },
  buttonActive: {
    '&.MuiButton-contained': {
      backgroundColor: isDark(theme) ? grey(theme, 800) : grey(theme, 500),
    },
  },
  chipFilters: {
    paddingTop: theme.spacing(2),
    paddingBottom: 0,

    '& > .MuiChip-root': {
      marginRight: theme.spacing(1),
    },
  },
  chartWrap: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
}));

export default useStyles;
